import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { showToast } from "@xpense/ui";
import { api } from "../api/client";

export default function GmailCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"processing" | "error">("processing");
  const [message, setMessage] = useState("Linking your Gmail account...");

  useEffect(() => {
    const code = searchParams.get("code");

    if (!code) {
      setStatus("error");
      setMessage("No authorization code received from Google.");
      return;
    }

    const redirectUri = `${window.location.origin}/gmail-callback`;

    api
      .post("/api/v1/gmail/callback", { code, redirect_uri: redirectUri })
      .then(() => {
        showToast("Gmail account linked successfully", "success");
        navigate("/connected-accounts", { replace: true });
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.message || "Failed to complete Gmail linking.");
      });
  }, [searchParams, navigate]);

  if (status === "processing") {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", flexDirection: "column", gap: "var(--xpn-space-lg)", background: "var(--xpn-bg)" }}>
        <div className="xpn-skeleton xpn-skeleton--card" style={{ width: 260, height: 48 }} />
        <p className="xpn-text-body-md xpn-text-muted">{message}</p>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", flexDirection: "column", gap: "var(--xpn-space-lg)", background: "var(--xpn-bg)", padding: "var(--xpn-space-xl)" }}>
      <p className="xpn-text-body-md xpn-text-danger">{message}</p>
      <button className="xpn-btn xpn-btn--secondary" onClick={() => navigate("/connected-accounts")}>
        Back to Connected Accounts
      </button>
    </div>
  );
}
